// Dependency import
import { APIGetCountryAndStateFullNames } from "../_api-get-country-and-state-full-names";
import { GetUTMParams }                   from "../_get-utm-params";
import { ZerobounceValidateEmail }        from "../_zerobounce-validate-email";

const FORM = ".js-form-subscribe";
const PRELOADER = ".js-form-subscribe";
const THANK_YOU = ".js-form-subscribe-thank-you";
const CLASSNAME_PRELOADER = "is-loading";

// Validation options
const VALIDATION_OPTIONS = {
	fields: {
		"firstname": {
			validators: {
				notEmpty: {
					message: "Please enter your first name"
				},
				stringLength: {
					min: 2,
					max: 20,
					message: "The first name must be between 2 and 20 characters long"
				}
			}
		},
		"email": {
			validators: {
				notEmpty: {
					message: "Please enter your email address"
				},
				emailAddress: {
					message: "Your email address should look like that John@example.com"
				},
                remote: {
                    message: "Please enter another email address"
                }
			}
		}
	},
    plugins: {
        message: new FormValidation.plugins.Message({
            clazz: 'form-error',
            container: function(field, element) {
                return element.closest( ".form-item" );
            }
        }),
        trigger: new FormValidation.plugins.Trigger(),
    }
};

// Formhandler
function HubspotFormhandlerSubscribe() {

    if ( ! document.querySelector( FORM ) ) return;

    const form = document.querySelector( FORM );

    let fv = FormValidation
        .formValidation( form, VALIDATION_OPTIONS );

    fv.disableValidator( "email", "remote" );

    const submit = form.querySelector( "[type='submit']" );
    submit.addEventListener( "click" , function ( event ) {
        event.preventDefault();

        fv.validate().then( function ( status ) {
            if ( status === "Valid" ) {

	            $( PRELOADER ).addClass( CLASSNAME_PRELOADER );

                let data = $( FORM ).serialize();

				// Add UTM parameters from string
				data += GetUTMParams();

				// Get user country and state
                APIGetCountryAndStateFullNames( false, false, function( location ) {
            
                    if ( location != "error" ) {
                        data += "&country=" + location.countryName;
                        if ( "US" === location.country ) {
                            data += "&state=" + location.stateName;
                        } else {
                            data += "&state=";
                        }
                    }

                    let urlParams = new URLSearchParams( data );
            
                    let unserializedData = {};
                    for ( let [ key, value ] of urlParams ) {
                        if ( unserializedData.hasOwnProperty( key ) ) {
                            unserializedData[ key ] += ", " + value;
                        } else {
                            unserializedData[ key ] = value;
                        }
                    }

					// ZeroBounce API check
	                ZerobounceValidateEmail( FORM + " input[name='email']", function ( response ) {
		                if ( response.status === "invalid" ) {
			                fv.updateFieldStatus( "email", "Invalid", "remote" );
			                $( PRELOADER ).removeClass( CLASSNAME_PRELOADER );
		                } else {

			                unserializedData.zero_bounce_status = response.status;

			                jQuery.ajax( {
				                url: gocoderzAjax.url,
				                type: "post",
				                data: {
					                action: "hubspot_subscribe_submit",
					                nonce: gocoderzAjax.nonce,
					                formData: unserializedData
				                },
				                success: function ( response ) {
					                if ( response == "success" ) {
						                $( THANK_YOU ).show();
						                $( FORM ).hide();
					                } else if ( response == "INVALID_EMAIL" ) {
						                fv.updateFieldStatus( "email", "Invalid", "remote" );
						                $( PRELOADER ).removeClass( CLASSNAME_PRELOADER );
					                } else {
						                $( PRELOADER ).removeClass( CLASSNAME_PRELOADER );
					                }
				                },
				                error: function ( error ) {
					                $( PRELOADER ).removeClass( CLASSNAME_PRELOADER );
				                }
			                } );
		                }
	                } );
                } );
            }
        })
    });
}

export { HubspotFormhandlerSubscribe };